import React, { useState, useEffect } from "react";
import Loader from "../../../Common/Loader/loader";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { Modal } from "react-bootstrap";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
import  TableSkeleton from "../../AllotedMaster/TableSkeleton";

const ViewGVPClearenceReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const date = localStorage.getItem("date");
  const { data, formatDate,shiftName } = location.state || {};
  const dataPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [scvList, setScvList] = useState(data);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage1, setSelectedImage1] = useState(null);
  const [showImageModal1, setShowImageModal1] = useState(false);
  const handlePageChange = (pageNumber) => {
    // Update the currentPage state
    setCurrentPage(pageNumber);
  };

  const fetchDataForPage = (pageNumber) => {
    // You can add your data fetching logic here
    // For example, fetch data from an API based on the pageNumber
    // Update the 'data' state with the fetched data
  };

  useEffect(() => {
    // Fetch initial data for the first page when the component mounts
    fetchDataForPage(currentPage);
  }, [currentPage]);
  const scvReportColumns = [
    {
      name: "S.No",
      width: "4%",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      cell: (row) => <span>{row["corporationName"] || "N/A"}</span>,
      sortable: true,
      width: "130px",
    },
    {
      name: "Zone",
      selector: (row) =>row["zoneName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["zoneName"]  || "N/A"}
        </span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Circle",
      selector: (row) =>row["circleName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"]  || "N/A"}
        </span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Ward",
      selector: (row) =>row["wardName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["wardName"]  || "N/A"}
        </span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <>Collection Point Name</>,
      selector: (row) =>row["collectionPointName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["collectionPointName"]  || "N/A"}
        </span>
      ),
      sortable: true,
      // width: "120px",
    },
    {
      name: <>Driver Name</>,
      selector: (row) =>row["driverName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["driverName"]  || "N/A"}
        </span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <>Driver Number</>,
      selector: (row) =>row["mobileNumber"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["mobileNumber"]  || "N/A"}
        </span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Number</>,
      selector: (row) =>row["vehicleNumber"],
      cell: (row) => <span>{row["vehicleNumber"]  || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    // {
    //   name: "TS Name",
    //   selector: (row) => (
    //     <span > {row["transferStationName"]  || "N/A"}</span>
    //   ),
    //   sortable: true,
    // },
    // {
    //   name: "TS Incharge Name",
    //   selector: (row) => (
    //     <span >{row["transferStationInchargeName"]  || "N/A"}</span>
    //   ),
    //   sortable: true,
    // },
    // {
    //   name: "Scanned Date",
    //   selector: (row) => (
    //     <span >{row["scannedDate"]  || "N/A"}</span>
    //   ),
    //   sortable: true,
    // },
   
    {
      name: <>Vehicle Type</>,
      selector: (row) =>row["vehicleTypeName"],
      cell: (row) => <span>{row["vehicleTypeName"]  || "N/A"}</span>,
      sortable: true,
      // width: "120px",
    },
    {
      name: <>Owner Type</>,
      selector: (row) =>row["ownerTypeName"],
      cell: (row) => <span>{row["ownerTypeName"]  || "N/A"}</span>,
      sortable: true,
      // width: "120px",
    },
    {
      name: <>Vehicle Capacity</>,
      selector: (row) =>row["vehicleCapacityName"],
      selector: (row) => <span>{row["vehicleCapacityName"]  || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
     {
      name: <>Latitude</>,
      selector: (row) =>row["collectionPointLatitude"],
      cell: (row) => <span>{row["collectionPointLatitude"]  || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Longitude</>,
      selector: (row) =>row["collectionPointLongitude"],
      cell: (row) => <span>{row["collectionPointLongitude"]  || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Before Image",
      cell: (row) => {
        if (row["beforeImageUrl"]) {
          return (
            <img
              src={row["beforeImageUrl"]}
              alt="Vehicle"
              style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: "10px", cursor: "pointer" }}
              onClick={() => handleImageClick(row.beforeImageUrl)}
            />
          );
        } else {
          return <span>No image</span>;
        }
      },
      sortable: true,
    },
    {
      name: "After Image",
      cell: (row) => {
        if (row["afterImageUrl"]) {
          return (
            <img
              src={row["afterImageUrl"]}
              alt=""
              style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: "10px", cursor: "pointer" }}
              onClick={() => handleImageClick1(row.afterImageUrl)}
            />
          );
        } else {
          return <span>No image</span>;
        }
      },
      sortable: true,
    },
  ];

  
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };
  const handleImageClick1 = (imageUrl) => {
    setSelectedImage1(imageUrl);
    setShowImageModal1(true);
  };

  const handleClose = () => {
    setShowImageModal(false);
    setSelectedImage(null);
    setShowImageModal1(false);
    setSelectedImage1(null);
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate back one step in the history stack
  };

  const exportToExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Zone Wise No of GVPs Cleared Reported SCV's at Circle Report as on ${formatDate ? formattedDate(formatDate) : getCurrentISTDate()} - ${shiftName} (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        // Apply styles to download date and time cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 6);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 7) {
        // Apply styles to cumulative heading report cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Corporation",
      "Zone",
      "Circle",
      "Ward",
      "Collection Point Name",
      "Driver Name",
      "Vehicle Number",
      "Contact No",
      "Vehicle Type",
      "Owner Type",
      "Vehicle Capacity",
      "Latitude",
      "Longitude",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 14) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    scvList.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.corporationName?? "N/A",
        item.zoneName?? "N/A",
        item.circleName?? "N/A",
        item.wardName?? "N/A",
        item.collectionPointName?? "N/A",
        item.driverName?? "N/A",
        item.vehicleNumber?? "N/A",
        item.mobileNumber?? "N/A",
        item.vehicleTypeName?? "N/A",
        item.ownerTypeName?? "N/A",
        item.vehicleCapacityName?? "N/A",
        item.collectionPointLatitude?? "N/A",
        item.collectionPointLongitude?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 14) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVsCircleReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const filterFields = { searchCircle: "", searchGVPPoint: ""};

  const searchReportedAtVehicleHandler = (values) => {
    const termCircle = values.searchCircle ? values.searchCircle.toLowerCase() : "";
    const termGVPPoint = values.searchGVPPoint ? values.searchGVPPoint.toLowerCase() : "";
   // const termGVPCode = values.searchGVPCode ? values.searchGVPCode.toLowerCase() : "";

    const filteredData = data.filter(item => {
      const circleName = item?.circleName ? item.circleName.toLowerCase() : "";
      const collectionPointName = item?.collectionPointName ? item.collectionPointName.toLowerCase() : "";
      //const vehicleUuid = item?.vehicleUuid ? item.vehicleUuid.toLowerCase() : "";

      const matchesCircle = !termCircle || circleName.includes(termCircle);
      const matchesGVPPoint = !termGVPPoint || collectionPointName.includes(termGVPPoint);
    //  const matchesGVPCode = !termGVPCode || vehicleUuid.includes(termGVPCode);

      return matchesCircle && matchesGVPPoint;
    });
    setScvList(filteredData);
  };
  
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                  <Formik initialValues={filterFields}>
                      {({ handleChange, values }) => (
                        <Form className="d-flex  align-items-center">
                          <div className="row">
                            <div className="col-md-6">
                              <div>
                                <Field
                                  name="searchCircle"
                                  placeholder="Search Circle"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({ ...values, searchCircle: e.target.value });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div>
                                <Field
                                  name="searchGVPPoint"
                                  placeholder="Search GVP Point"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({ ...values, searchGVPPoint: e.target.value });
                                  }}
                                />
                              </div>
                            </div>
                            {/* <div className="col-md-3">
                              <div>
                                <Field
                                  name="searchGVPCode"
                                  placeholder="Search GVP Code"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({ ...values, searchGVPCode: e.target.value });
                                  }}
                                />
                              </div>
                            </div> */}
                          </div>
                        </Form>
                      )}
                    </Formik>
                    <div className="d-flex">
                    <button
                      className="btn btn-secondary me-2"
                      onClick={handleBackClick}
                    >
                      Back
                    </button>
                    <button
                      className="btn btn-excel"
                      onClick={exportToExcel}
                    >
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                    </div>
                   
                  </div>


                  <div className="top-header">
                    <span>
                      {" "}
                      Zone Wise No of GVPs Cleared Reported SCV's at Circle Report as on {formatDate ? formattedDate(formatDate) : getCurrentISTDate()} - {shiftName} (at {getCurrentDateTime1()})
                    </span>
                  </div>

                  { isLoading?<TableSkeleton/>:<CustomDataTable
                    data={scvList}
                    columns={scvReportColumns}
                    pagination
                    dataPerPage={dataPerPage}
                    currentPage={currentPage}
                    handlePageChange={handlePageChange}
                  // headers={headers}
                  // link={true}
                  // search={true}
                  // fromDate={fromDate}
                  // toDate={toDate}
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <Modal show={showImageModal} onHide={handleClose} centered>
        <Modal.Header closeButton><Modal.Title>Before Image</Modal.Title></Modal.Header>
        <Modal.Body>
          <img src={selectedImage} alt="Full vehicle" style={{ width: "100%", height: "400px", borderRadius: "5px", objectFit: "contain" }} />
        </Modal.Body>
      </Modal>
      <Modal show={showImageModal1} onHide={handleClose} centered>
        <Modal.Header closeButton><Modal.Title>After Image</Modal.Title></Modal.Header>
        <Modal.Body>
          <img src={selectedImage1} alt="Full vehicle" style={{ width: "100%", height: "400px", borderRadius: "5px", objectFit: "contain" }} />
        </Modal.Body>
      </Modal>
    </>
  );
};

// Function to get default date in "YYYY-MM-DDTHH:MM" format
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export default ViewGVPClearenceReport;
